import type { InfringementStatusEventDto } from '@carvia/ros-client-types';
import { ServerSentEventService } from './server-sent-event.service';

export const infringementStatusEventsService = () =>
  new ServerSentEventService<InfringementStatusEventDto>('/infringements/events');
